"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveSSRPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const media_constants_1 = require("../../media-query/media-constants");
const MediaQueryContext_1 = require("../../media-query/MediaQueryContext");
const media_query_1 = require("../../media-query");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
/**
 * Component that makes a page responsive for SSR purposes
 * Make sure that the component is at the top of the page.
 *
 * Make sure any call to useDesktopMediaQuery, useMobileMediaQuery or useTabletMediaQuery hook are made in a component that is inside the tree wrapped by this component
 */
function ResponsiveSSRPage({ isMobileServerSide = true, deviceType, app, children, }) {
    const [mounted, setMounted] = (0, react_1.useState)(false);
    const widthOverride = (0, react_1.useMemo)(() => {
        if (mounted) {
            // no override when on client side
            return undefined;
        }
        if (deviceType) {
            // categorising crawlers as mobile devices
            // - for web capture link preview, our preview pages are device-agnostic
            // - for Google crawlers, 97% of requests are from Smartphone Googlebots.
            // Possible values: https://grafana-dashboard.sc-corp.net/d/dweb_file_server_metrics/desktop-web-file-server?orgId=1&editPanel=59
            return ["mobile", "undetermined"].includes(deviceType) ? media_constants_1.MOBILE_MAX_WIDTH : media_constants_1.TABLET_MAX_WIDTH;
        }
        return isMobileServerSide ? media_constants_1.MOBILE_MAX_WIDTH : media_constants_1.TABLET_MAX_WIDTH;
    }, [isMobileServerSide, mounted, deviceType]);
    (0, react_1.useEffect)(() => {
        setMounted(true);
    }, []);
    return ((0, jsx_runtime_1.jsx)(MediaQueryContext_1.MediaQueryProvider, { widthOverride: widthOverride, children: (0, jsx_runtime_1.jsx)(PageContent, { app: app, isMounted: mounted, isMobileServerSide: isMobileServerSide, deviceType: deviceType, children: children }) }));
}
exports.ResponsiveSSRPage = ResponsiveSSRPage;
function PageContent({ isMobileServerSide, app = "unknown", isMounted, deviceType, children, }) {
    const isMobile = (0, media_query_1.useMobileMediaQuery)();
    (0, react_1.useEffect)(() => {
        if (!isMounted)
            return;
        const expected = deviceType ?? (0, web_graphene_reporting_1.getDeviceName)(isMobileServerSide).toLowerCase();
        const actual = (0, web_graphene_reporting_1.getDeviceName)(isMobile).toLowerCase();
        void (0, web_graphene_reporting_1.incrementCounter)("web_frame.content_targeting", 1, {
            app,
            expected,
            actual,
        });
    }, [isMobile, isMobileServerSide, isMounted, app, deviceType]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
}
//# sourceMappingURL=index.js.map